import { FormField, SpaceBetween } from '@amzn/awsui-components-core';
import Input from '@amzn/awsui-components-core/input';
import { FormikProps, getIn } from 'formik';
import React from 'react';
import { ApplicationFormValues } from '../../AdminModels';

interface QChatConfigProps {
  formik: FormikProps<ApplicationFormValues>;
}

const QChatConfig: React.FC<QChatConfigProps> = ({ formik }) => {
  const isEnabled = formik.values.applicationDetails?.qChatConfig?.isEnabled || false;

  if (!isEnabled) {
    return null;
  }

  return (
    <SpaceBetween size="m" direction="vertical">
      <FormField
        label="QuickSight Agent URL"
        constraintText="Full https:// QuickSight embed URL"
        errorText={
          getIn(formik.touched, 'applicationDetails.qChatConfig.agentUrl') && getIn(formik.errors, 'applicationDetails.qChatConfig.agentUrl')
        }
      >
        <Input
          placeholder="https://us-east-1.quicksight.aws.amazon.com/sn/account/..."
          onChange={({ detail }) => formik.setFieldValue('applicationDetails.qChatConfig.agentUrl', detail.value)}
          onBlur={() => formik.setFieldTouched('applicationDetails.qChatConfig.agentUrl', true)}
          value={formik.values.applicationDetails?.qChatConfig?.agentUrl || ''}
        />
      </FormField>
    </SpaceBetween>
  );
};

export default QChatConfig;
